"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubscriptionTypeTrads = void 0;
exports.ESubscriptionTypeTrads = {
    legalPerson: "Personne morale",
    naturalPerson: "Personne physique",
    coSubscriptionNaturalPerson: "Personne physique en co-souscription",
};
